import axios from 'axios';

// detect op param on initial load and persist to localStorage
const urlParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const opParam = urlParams ? urlParams.get('op') : null;
if (opParam === 'e') {
    localStorage.setItem('op', 'e');
}

// decide whether to use ETI endpoints
const useEti = (localStorage.getItem('op') === 'e') || (opParam === 'e');

// selected base and login urls
export const BASE_URL = useEti ? process.env.REACT_APP_BASE_ETI : process.env.REACT_APP_BASE_URL;
export const LOGIN_URL = useEti ? process.env.REACT_APP_LOGIN_URL_ETI : process.env.REACT_APP_LOGIN_URL;

// create axios client with chosen base URL
const axiosClient = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    })

    failedQueue = [];
}

// Request Interceptor: Add token to headers
axiosClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle 401 and token refresh
axiosClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // Check if it's a 401 error and we haven't already retried
        if (error.response && error.response.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return Promise.reject(new Error("Token refreshongoing."));
            }

            originalRequest._retry = true;
            isRefreshing = true;

            let msisdn = localStorage.getItem('msisdn');
            let refferer = localStorage.getItem('refferer');
            if (!refferer) {
                const urlParams = new URLSearchParams(window.location.search);
                refferer = urlParams.get('refferer') || urlParams.get('referer');
            }

            if (!msisdn) {
                const urlParams = new URLSearchParams(window.location.search);
                const msisdnFromUrl = urlParams.get('a');
                if (msisdnFromUrl) {
                    msisdn = msisdnFromUrl;
                    localStorage.setItem('msisdn', msisdn);
                } else {
                    // console.error("MSISDN not found in localStorage or URL.");
                    return Promise.reject(new Error("MSISDN not found"));
                }
            }

            try {
                let refreshResponse;
                // use chosen BASE_URL for refresh endpoint
                if (refferer === 'gamenow') {
                    refreshResponse = await axios.post(`${BASE_URL}/v1/jt/gen`, { msisdn, refferer });
                } else {
                    refferer = null;
                    refreshResponse = await axios.post(`${BASE_URL}/v1/jt/gen`, { msisdn, refferer });
                }
                const newToken = refreshResponse.headers['access_token'];
                if (newToken) {
                    localStorage.setItem('access_token', newToken);
                    axiosClient.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
                    originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
                    processQueue(null, newToken);
                    return axiosClient(originalRequest);
                } else {
                    throw new Error("No token received from refresh endpoint");
                }
            } catch (refreshError) {
                // console.error('Token refresh failed:', refreshError);
                processQueue(refreshError, null);
                localStorage.removeItem('access_token');
                localStorage.removeItem('msisdn');
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        // console.error('API Error:', error);
        return Promise.reject(error);
    }
);

export default axiosClient;